import useApiClient from './api-client'
import type { CategoryResponseInfo } from '@/types/api'

export const getCategory = async (categoryId: number | string, regionId: number | string) => {
  const api = useApiClient<CategoryResponseInfo>()
  const result = await api(`/category/${categoryId}`, {
    query: {
      region_id: regionId,
    },
  })

  return result
}
